<template>
    <div class="app-body">
        <bread-crumb></bread-crumb>
        <el-card class="content">
            <el-form :model="form" ref="form" :rules="rules" label-width="140px" label-position="left">
                <!-- <el-form-item label="选择站点" prop="targetId" >
                    <div class="a-flex-rfsc">
                        <le-select-remote-search style="padding: 0 !important" v-model="form.targetId" :options="optionsUnderlying" placeholder="请选择（可输入搜索）" />
                    </div>
                </el-form-item> -->
                <el-form-item label="输入站点" prop="stationIdText">
                    <el-input
                        type="textarea"
                        :rows="4"
                        style="width: 400px"
                        @blur='getStationInfoByIds'
                        placeholder="请输入站点ID；以英文逗号或换行符隔开"
                        v-model="form.stationIdText">
                    </el-input>
                </el-form-item>
                <el-form-item label="广告设置">
                    <div class="a-flex-rfsc">
                        <el-button type="primary" plain size='mini' @click="handleStartAll">全部启用</el-button>
                        <el-button type="danger" plain size='mini' @click="handleCloseAll">全部关闭</el-button>
                    </div>
                    <el-table :data="baseAdList" class="a-mt-10">
                        <el-table-column label="广告名称" prop='name'></el-table-column>
                        <el-table-column label="广告编码" prop='adLocationId'></el-table-column>
                        <el-table-column label="广告平台">
                            <template slot-scope="{ row }">
                                {{ row.appId | initDic(appidListDic) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="{ row }">
                                <el-radio-group v-model="row.showType">
                                    <el-radio :label="1">启用</el-radio>
                                    <el-radio :label="0">关闭</el-radio>
                                </el-radio-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="广告关闭时长" prop="reStartDay">
                    <el-radio-group v-model="form.reStartDay" @change='reStartDayChange'>
                        <el-radio-button :label="7">7天</el-radio-button>
                        <el-radio-button :label="15">15天</el-radio-button>
                        <el-radio-button :label="30">30天</el-radio-button>
                        <el-radio-button :label="-1">永久</el-radio-button>
                        <el-radio-button :label="99">其他</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="广告恢复展示时间" prop="adReStartTime">
                    <el-date-picker
                        value-format='yyyy-MM-dd'
                        :disabled='form.reStartDay != 99'
                        v-model="form.adReStartTime"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div style="height: 100px;"></div>
            <div class="a-line-t-e0 footerBox">
                <el-button type="primary" class="a-ml-24 a-mt-15" @click="submit">立即提交</el-button>
                <el-button class="a-ml-24 a-mt-15" style="margin-left: 24px" @click="cancelSubmit">返回</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                id: '',
                form: {
                    "adAuthScop": 0,
                    "reStartDay": 30,
                    adReStartTime: this.$getDay.getTodayBeforeDays(-30),
                    stationIdText: '',
                },
                rules: {
                    stationIdText: [{required: true, message:'请输入站点ID', trigger: 'blur'}],
                },
                baseAdList: [],//基础广告位列表
                appidListDic: [
                    {
                        label: '毛豆充（微信小程序）',
                        value: 'hichar.user.wxapp'
                    },
                    {
                        label: '毛豆充（支付宝小程序）',
                        value: 'hichar.user.aliapp'
                    },
                    {
                        label: '玖电毛豆充（云闪付小程序）',
                        value: 'hichar.user.unapp'
                    },
                    {
                        label: '安心e充（微信小程序）',
                        value: 'hichar.user.rest.wxapp'
                    },
                    {
                        label: '智慧e充（微信小程序）',
                        value: 'hichar.user.black.wxapp'
                    }
                ]
            };
        },
        created () {
            this.$getDic('importLevel','select').then(res=>{ this.importanceLevelDic = res; })
            this.id = this.$route.query.id
            this.getBaseAdList()
            if(this.id) this.getInfo()
        },
        mounted () {

        },
        methods: {
            getBaseAdList () {
                this.$Axios._get({
                    url: this.$Config.apiUrl.stationFrontAdBaseList,
                })
                .then(({data})=>{
                    this.baseAdList = data.map(item=>{
                        return {
                            ...item,
                            showType: 0
                        }
                    })
                })
                .catch(err=>{

                })
            },
            handleStartAll () {
                if(this.baseAdList && this.baseAdList.length) {
                    this.baseAdList = this.baseAdList.map(item=>{
                        return {
                            ...item,
                            showType: 1
                        }
                    })
                }
            },
            handleCloseAll () {
                if(this.baseAdList && this.baseAdList.length) {
                    this.baseAdList = this.baseAdList.map(item=>{
                        return {
                            ...item,
                            showType: 0
                        }
                    })
                }
            },
            reStartDayChange () {
                if(this.form.reStartDay != -1 && this.form.reStartDay != 99) {
                    this.form.adReStartTime = this.$getDay.getTodayBeforeDays(-this.form.reStartDay)
                }else {
                    this.form.adReStartTime = ''
                }
            },
            getStationInfoByIds () {
                if(this.form.stationIdText) {
                    this.form.stationIdText = this.form.stationIdText.replace(/，| |[\r\n]/g, ',');
				}
            },
            getInfo () {
                this.$Axios._get({
                    url: this.$Config.apiUrl.underlyingInfo,
                    params: {
                        id: this.id
                    },
                })
                .then(({data})=>{
                    this.form = {
                        ...data,
                        dateRange: [this.$getDay.getTimeStampToStr(data.startDate, 'YYYY-MM-DD'), this.$getDay.getTimeStampToStr(data.endDate, 'YYYY-MM-DD')],
                        investAmount: data.investAmount ? Number((data.investAmount/100).toFixed(2)) : '',
                        baseAmount: data.baseAmount ? Number((data.baseAmount/100).toFixed(2)) : '',
                    }
                })
                .catch(err=>{

                })
            },
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if(!this.form.stationIdText) {
                            this.$message.warning('请至少输入一个站点ID')
                            return
                        }
                        if(this.form.reStartDay == 99 && !this.form.adReStartTime) {
                            this.$message.warning('广告关闭天数为其他时，请选择广告恢复展示时间')
                            return
                        }
                        this.$confirm('是否确认提交？', '温馨提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(_=>{
                            let reqData
                            reqData = {
                                "adSetValue": {
                                    "adList": this.baseAdList,
                                    "adReStartTime": this.form.adReStartTime,
                                    "reStartDay": this.form.reStartDay
                                },
                                "stationIds": this.form.stationIdText.split(',')
                            }
                            this.$Axios._post({
                                url: this.$Config.apiUrl.setStationAd,
                                method: "post",
                                params: reqData,
                            })
                            .then(({data})=>{
                                let failStationId = data.failStationIdList && data.failStationIdList.length ? data.failStationIdList.join('、') : '无'
                                const h = this.$createElement;
                                this.$msgbox({
                                    title: '广告设置成功',
                                    message: h('div', null, [
                                        h('p', { style: 'color: #67C23A' }, `成功数量：${data.successNum}`),
                                        h('p', { style: 'color: #F56C6C' }, `失败数量：${data.failNum}`),
                                        h('p', { style: 'color: #F56C6C' }, `失败站点ID：${failStationId}`),
                                    ]),
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                }).then(_=>{
                                    this.$router.back()
                                    this.$store.dispatch("delView", this.$route);
                                }).catch(err=>{
                                    // this.$router.back()
                                    // this.$store.dispatch("delView", this.$route);
                                })
                            })
                            .catch(err=>{

                            })
                        }).catch(err=>{ console.log(err); })
                    }
                })
                
            },
            cancelSubmit () {
                this.$confirm('是否确认返回？','温馨提示')
                .then(_=>{
                    this.$router.back()
                    this.$store.dispatch("delView", this.$route);
                })
                .catch(_=>{})
            },
        },
    }
</script>

<style lang="scss" scoped>
    .content{
        font-size: 14px;
        height: 100%;
        overflow-y: auto;
        .subsidy-content{
            padding: 10px;
            border-radius: 4px;
            background: #F2F6FC;
            margin-top: 10px;
            width: fit-content;
        }
        /deep/ .el-range-separator{
            width: 20px !important;
        }
        .carryVoPlatform{
            width: 240px;
            height: 32px;
            line-height: 32px;
            padding: 0 15px;
            background: #f5f7fa;
            border: 1px solid #e4e7ed;
            border-radius: 4px;
            color: #c0c4cc;
        }
    }
</style>